import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-redirect-sso-techsupport',
    templateUrl: './redirect-sso-techsupport.component.html',
    styleUrls: ['./redirect-sso-techsupport.component.scss'],
    standalone: false
})
export class RedirectSsoTechsupportComponent implements OnInit {

  constructor(private router: Router, private msalService: MsalService) { }

  ngOnInit(): void {
    sessionStorage.clear();
    this.msalService.logoutRedirect({
      postLogoutRedirectUri: environment.impersonate_url
    });
  }

}
